
import axios from 'axios';
import { toast } from 'sonner';

const apiUtils = {
  post: async (url, data, options = {}) => {
    const {
      showToast = false,
      setData = null,
      redirectUrl = null,
      headers = {},
    } = options;

    const jwtToken = localStorage.getItem('jwt');

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-JWT-Token': jwtToken,
        ...headers, 
      },
    };

    try {
      const response = await axios.post(`${import.meta.env.VITE_APP_API}${url}`, data, config);

      if (response.data.Success) {
        if (setData) setData(response.data.Success);
        if (redirectUrl) {
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 250);
        }
        if (showToast) toast.success(response.data.Success);
        return response.data;
      } else {
        if (showToast) toast.error(response.data.Error );
        return null;
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.Error ;
      if (showToast) toast.error(errorMsg);
      throw error;
    }
  },
};

export default apiUtils;
